export default __webpack_public_path__ + "static/media/backgroundVideoChat.a32ff13f.mp4";